<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-breadcrumbs :items="breadcrumbs">
					<template #divider>
						<v-icon>mdi-chevron-left</v-icon>
					</template>
				</v-breadcrumbs>
			</v-col>
		</v-row>
		
		<v-row justify="center" no-gutters class="pa-2">
			<v-col cols="12" md="7" lg="6" xl="5">
				<v-row justify="center" class="mx-6 pa-2">
					<v-col cols="12">
						<v-file-input
							v-model="newPic"
							accept="image/png"
							prepend-inner-icon="mdi-camera"
							prepend-icon
							label="تغير الصورة"
							outlined
							hide-details="auto"
						></v-file-input>
					</v-col>
					<v-col cols="6">
						<v-select
							v-model="yPosition"
							outlined
							hide-details="auto"
							label="الموضع العامودي"
							:items="yPositions"
							item-text="name"
						></v-select>
					</v-col>
					<v-col cols="6">
						<v-select
							v-model="xPosition"
							outlined
							hide-details="auto"
							label="الموضع الأفقي"
							:items="xPositions"
							item-text="name"
						></v-select>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="temp"
							outlined
							:error="invalid"
							append-icon="mdi-percent"
							hide-details="auto"
							label="نسبة الحجم"
						></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field
							v-model="yDisplacement"
							outlined
							hide-details="auto"
							label="الإزاحة العامودية"
						></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field
							v-model="xDisplacement"
							outlined
							hide-details="auto"
							label="الإزاحة الأفقية"
						></v-text-field>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="5" lg="4" xl="3">
				<v-row justify="center" dense class="text-center">
					<v-col cols="12">
						<v-card height="250" width="250" class="mx-auto">
							<v-row :justify="xPosition" :align="yPosition" no-gutters class="fill-height" :style="'padding:' + yDisplacement+'px '+xDisplacement +'px'">
								<v-img v-if="newPic" :height="2.5 * resolution" contain :style="'opacity:' + transparency / 100" :src="newPic | imgToURL" :position="imgPosition"></v-img>
								<v-img v-else-if="imagePath" :height="2.5 * resolution" contain :style="'opacity:' + transparency / 100" :src="imagePath" :position="imgPosition"></v-img>
							</v-row>
						</v-card>
					</v-col>

					<v-col cols="12" style="max-width: 250px;">
						<v-subheader>الشفافية</v-subheader>
						<v-slider
							v-model="transparency"
							dense
							>
						</v-slider>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols="12" class="text-center">
				<v-btn color="primary" :disabled="!privs.manage" :loading="loading" @click="update">تحديث</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'العلامة المائية', disabled: true }
			],
			yPositions: [{name: "أعلى", value: "start"},
				{name: "منتصف", value: "center"},
				{name: "أسفل", value: "end"}],
			xPositions: [{name: "يمين", value: "start"},
				{name: "منتصف", value: "center"},
				{name: "يسار", value: "end"}],
			xPosition: null,
			yPosition: null,
			newPic: null,
			transparency: 0,
			resolution: 0,
			temp: 0,
			invalid: false,
			yDisplacement: 0,
			xDisplacement: 0,
			imagePath: null,
			placeholder: "",
			imageView: null,
			loading: false
		};
	},
	computed:{
		imgPosition(){
			if(this.xPosition == "start")
				return "center right";
			if(this.xPosition == "end")
				return "center left";
			
			return "center center";
		},
		privileges() {
			const privs = this.privs;
			if (privs == undefined || Object.keys(privs).length == 0) {
				return {};
			}
			return privs;
		}
	},
	watch: {
		temp (newVal){
			if (isNaN(newVal)){
				setTimeout(() => {
					this.temp = 20
				}, 0)
			}else if (newVal > 100){
				this.invalid = true
			}else {
				this.resolution = this.temp
				this.invalid = false
			}
		}
	},
	mounted() {
		this.getPrivileges();
		this.getWatermark();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/waterMarkIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getWatermark() {
			this.loading = true;

			client
				.get("/api/system/watermark")
				.then(response => {
					console.log(response);
					var newData = response.data.data;
					this.yDisplacement = newData.yOffset
					this.xDisplacement = newData.xOffset
					this.resolution = newData.height * 100
					this.temp = this.resolution
					this.transparency = newData.opacity
					var baseURL = client.defaults.baseURL;

					if (newData.imagePath) {
						if(newData.imagePath.indexOf(baseURL) == -1) {
							this.imagePath = baseURL + newData.imagePath.replace("/public/",'');
						} else {
							this.imagePath = newData.imagePath.replace("/public/",'');
						}
					}

					if (newData.placeholder) {
						if(newData.placeholder.indexOf(baseURL) == -1) {
							this.placeholder = baseURL + newData.placeholder.replace("/public/",'');
						} else {
							this.placeholder = newData.placeholder.replace("/public/",'');
						}
					}

					if (newData.imageView) {
						if(newData.imageView.indexOf(baseURL) == -1) {
							this.imageView = baseURL + newData.imageView.replace("/public/",'');
						} else {
							this.imageView = newData.imageView.replace("/public/",'');
						}
					}

					if (newData.positions == "top-left") {
						this.yPosition = "start"
						this.xPosition = "end"
					} else if (newData.positions == "top-center") {
						this.yPosition = "start"
						this.xPosition = "center"
					} else if (newData.positions == "top-right") {
						this.yPosition = "start"
						this.xPosition = "start"
					} else if (newData.positions == "center-left") {
						this.yPosition = "center"
						this.xPosition = "end"
					} else if (newData.positions == "center-center") {
						this.yPosition = "center"
						this.xPosition = "center"
					} else if (newData.positions == "center-right") {
						this.yPosition = "center"
						this.xPosition = "start"
					} else if (newData.positions == "bottom-left") {
						this.yPosition = "end"
						this.xPosition = "end"
					} else if (newData.positions == "bottom-center") {
						this.yPosition = "end"
						this.xPosition = "center"
					} else {
						this.yPosition = "end"
						this.xPosition = "start"
					}
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		},
		update(){
			this.loading = true;
			var position = "";
			
			if (this.yPosition == "start"){
				position = "top-"
			} else if (this.yPosition == "center"){
				position = "center-"
			} else if (this.yPosition == "end"){
				position = "bottom-"
			}

			if (this.xPosition == "start"){
				position = position + "right"
			} else if (this.xPosition == "center"){
				position = position + "center"
			} else if (this.xPosition == "end"){
				position = position + "left"
			}

			var data = new FormData();
			
			data.append('image', this.imagePath);
			data.append('height', this.resolution / 100);
			data.append('yOffset', this.yDisplacement);
			data.append('xOffset', this.xDisplacement);
			data.append('positions', position);
			data.append('opacity', this.transparency);
			data.append('logo', this.newPic);

			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			clientNotifier
				.post("/api/system/updateWatermark", data, config)
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>